import * as S from "@dcspark/cardano-multiplatform-lib-nodejs";
export const JsonDeserializableEntities = [
    S.Address,
    S.AssetName,
    S.AssetNames,
    S.Assets,
    S.AuxiliaryData,
    S.Block,
    S.BootstrapWitness,
    S.Certificate,
    S.Certificates,
    S.Ed25519KeyHashes,
    S.GeneralTransactionMetadata,
    S.GenesisHashes,
    S.GenesisKeyDelegation,
    S.Header,
    S.HeaderBody,
    S.Ipv4,
    S.Ipv6,
    S.MIRToStakeCredentials,
    S.Mint,
    S.MoveInstantaneousReward,
    S.MoveInstantaneousRewardsCert,
    S.MultiAsset,
    S.MultiHostName,
    S.NativeScript,
    S.NetworkId,
    S.OperationalCert,
    S.PoolMetadata,
    S.PoolParams,
    S.PoolRegistration,
    S.PoolRetirement,
    S.ProposedProtocolParameterUpdates,
    S.ProtocolParamUpdate,
    S.ProtocolVersion,
    S.Relay,
    S.Relays,
    S.RewardAddresses,
    S.ScriptAll,
    S.ScriptAny,
    S.ScriptHashes,
    S.ScriptNOfK,
    S.ScriptPubkey,
    S.SingleHostAddr,
    S.SingleHostName,
    S.StakeCredential,
    S.StakeCredentials,
    S.StakeDelegation,
    S.StakeDeregistration,
    S.StakeRegistration,
    S.TimelockExpiry,
    S.TimelockStart,
    S.Transaction,
    S.TransactionBodies,
    S.TransactionBody,
    S.TransactionInput,
    S.TransactionInputs,
    S.TransactionOutput,
    S.TransactionOutputs,
    S.TransactionWitnessSet,
    S.TransactionWitnessSets,
    S.UnitInterval,
    S.Update,
    S.VRFCert,
    S.Value,
    S.Vkeywitness,
    S.Withdrawals,
];
export const JsonSerializableEntities = JsonDeserializableEntities;
//# sourceMappingURL=JsonSerializableEntities.js.map